import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { UserM } from '../../models/user.types';
import { ButtonOne } from '../ButtonOne/ButtonOne.component';
import { useStyles, styles } from './ExaminerDataForm.styles';
import { getExamCommitteeNameFromIdString } from '../../pages/SampleAssessmentRepo/Helpers/AccountTypeRendering';
import usePermission from '../../hooks/usePermission';
import { UserPermission } from '../../enum/userPermissions';
import CloseButton from '../buttons/CloseButtton.component';
import { formatPhone } from '../UserProfile/helpers';

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}
const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, ...other } = props;
  return (
    <MuiDialogTitle className={classes.root} {...other}>
      {children}
    </MuiDialogTitle>
  );
});

interface ExaminerDataFormProps {
  userArg: UserM;
  goToEdit: () => void;
  closeModal: () => void;
}

export default function ExaminerDataForm(props: ExaminerDataFormProps) {
  const [, setOpen] = useState<boolean>(false);

  const permissionAdminExaminerCreate = usePermission(UserPermission.AdminExaminerCreate);
  const permissionAdminUserCreate = usePermission(UserPermission.AdminUserCreate);
  const permissionAdminOkeExaminerCreate = usePermission(UserPermission.AdminOkeExaminerCreate);

  const handleClose = () => {
    props.closeModal();
    setOpen(false);
  };

  const classes = useStyles();

  return (
    <>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <Grid container>
          <Grid item xs={6}>
            <div className={classes.modalTitle}>
              {props.userArg.firstName} {props.userArg.lastName}
            </div>
          </Grid>
          <Grid item xs={6}>
            <CloseButton onClick={handleClose} />
          </Grid>

          <Grid item xs={6}>
            <div className={classes.leftText}>Imię i nazwisko</div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.rightText}>
              {props.userArg.firstName} {props.userArg.lastName}
            </div>
          </Grid>

          <hr className={classes.line}></hr>

          <Grid item xs={6}>
            <div className={classes.leftText}>PESEL</div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.rightText}>{props.userArg.pesel}</div>
          </Grid>

          <hr className={classes.line}></hr>

          <Grid item xs={6}>
            <div className={classes.leftText}>Nr telefonu</div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.rightText}>{formatPhone(props.userArg.phone)}</div>
          </Grid>

          <hr className={classes.line}></hr>

          <Grid item xs={6}>
            <div className={classes.leftText}>E-mail</div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.rightText}>{props.userArg.email}</div>
          </Grid>

          <hr className={classes.line}></hr>

          <Grid item xs={6}>
            <div className={classes.leftText}>Komisja</div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.rightText}>{getExamCommitteeNameFromIdString(+props.userArg.examCommitteeId)}</div>
          </Grid>

          <hr className={classes.line}></hr>

          <Grid item xs={6}>
            <div className={classes.leftText}>Status konta</div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.rightText}>{props.userArg.emailConfirmed ? 'Aktywny' : 'Nieaktywny'}</div>
          </Grid>
          <ButtonOne
            className={classes.editUserButton}
            variant="contained"
            color="primary"
            onClick={props.goToEdit}
            disabled={!permissionAdminExaminerCreate && !permissionAdminOkeExaminerCreate}
          >
            edytuj dane
          </ButtonOne>
        </Grid>
      </DialogTitle>
    </>
  );
}
